var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubscription = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 21 21",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.0381 4.01855v2.97413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.0635 6.99268h2.9743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.3357 6.99282c-.8183-2.05841-2.3299-3.76623-4.2736-4.82858-1.9438-1.06235-4.1977-1.412279-6.37215-.98949-2.17446.42279-4.13293 1.59164-5.53699 3.30493-1.40406 1.71328-2.165541 3.86315-2.1528 6.07822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.02053 10.5579c-.00504 2.4213.91444 4.7535 2.57072 6.5199 1.65629 1.7664 3.92442 2.834 6.34127 2.9848 2.41688.1508 4.80018-.6266 6.66318-2.1734 1.8631-1.5468 3.0653-3.7465 3.3613-6.1497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.40918 8.17456 4.11522 2.38334 4.1154-2.38334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5244 10.5579v4.7465"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.7722 12.4626v-3.81963c-.0053-.16522-.0506-.32675-.1323-.47049-.0816-.14374-.197-.26543-.3362-.35461l-3.3005-1.90461c-.1461-.07673-.3086-.11687-.4736-.11687s-.3275.04014-.4736.11687l-3.30036 1.90461c-.14306.08496-.26152.20571-.34368.35038-.08217.14468-.12516.30834-.12484.47472v3.80943c-.00059.1651.04243.3274.12471.4705s.20086.2619.34381.3444l3.30036 1.9046c.1433.0852.3069.1303.4736.1303s.3303-.0451.4736-.1303l3.3005-1.9046c.1401-.0831.2566-.2008.3386-.3416.082-.1409.1267-.3002.1299-.4631z",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubscription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subscription.2429a57a99232022acc11e785d659b29.svg";